/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { RptId } from "./RptId";
import { AmountEuroCents } from "./AmountEuroCents";
import { Transfer } from "./Transfer";
import * as t from "io-ts";

/**
 * Informations about transaction payments
 */

// required attributes
const PaymentInfoR = t.interface({
  rptId: RptId,

  amount: AmountEuroCents,

  isAllCCP: t.boolean,

  transferList: t.readonlyArray(Transfer, "array of Transfer")
});

// optional attributes
const PaymentInfoO = t.partial({
  paymentToken: t.string,

  reason: t.string,

  creditorReferenceId: t.string
});

export const PaymentInfo = t.intersection(
  [PaymentInfoR, PaymentInfoO],
  "PaymentInfo"
);

export type PaymentInfo = t.TypeOf<typeof PaymentInfo>;
